import React, { useRef, useEffect } from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';

// 37 Vryburger Avenue, Bothasig, Cape Town (lng, lat from OpenStreetMap)
const BMCS_CENTER: [number, number] = [18.5351429, -33.8637822];

interface ContactMapProps {
  className?: string;
}

interface MapboxMap {
  remove: () => void;
}

const ContactMap: React.FC<ContactMapProps> = ({ className = '' }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const mapRef = useRef<MapboxMap | null>(null);

  useEffect(() => {
    const token = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
    if (!token || !containerRef.current) return;

    let cancelled = false;

    import('mapbox-gl').then((mapboxgl) => {
      if (cancelled || !containerRef.current) return;
      mapboxgl.default.accessToken = token;
      const map = new mapboxgl.default.Map({
        container: containerRef.current,
        style: 'mapbox://styles/mapbox/light-v11',
        center: BMCS_CENTER,
        zoom: 15,
        interactive: false,
      });
      map.on('load', () => {
        if (cancelled) return;
        new mapboxgl.default.Marker({ color: '#2c5530' }).setLngLat(BMCS_CENTER).addTo(map);
      });
      mapRef.current = map;
    });

    return () => {
      cancelled = true;
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, []);

  return <div ref={containerRef} className={className} aria-label="Map showing BMCS location" />;
};

export default ContactMap;
